import { render, staticRenderFns } from "./PowerDistributionCabinet.vue?vue&type=template&id=de06dec6&scoped=true&"
import script from "./PowerDistributionCabinet.vue?vue&type=script&lang=js&"
export * from "./PowerDistributionCabinet.vue?vue&type=script&lang=js&"
import style0 from "./PowerDistributionCabinet.vue?vue&type=style&index=0&id=de06dec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de06dec6",
  null
  
)

export default component.exports